var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "container",
          class: { "plus-container": _vm.plusContainer }
        },
        [
          _c(
            "header",
            [
              _c("div", { staticClass: "navigation" }, [
                _c(
                  "span",
                  { staticStyle: { cursor: "pointer" } },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "menu",
                        on: {
                          click: function($event) {
                            return _vm.$router.push({ path: "/" })
                          }
                        }
                      },
                      [_vm._v("Home")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticStyle: { margin: "0 10px" } }, [
                      _vm._v("/")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.form.menuList, function(item, index) {
                      return _c("span", { key: item.id }, [
                        _c(
                          "a",
                          {
                            staticClass: "menu",
                            on: {
                              click: function($event) {
                                return _vm.gotoShopvidi(item)
                              }
                            }
                          },
                          [
                            _vm._v(_vm._s(item.title)),
                            index !== _vm.form.menuList.length - 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "menu",
                                    staticStyle: { margin: "0 10px" }
                                  },
                                  [_vm._v("/")]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("el-divider")
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "goods-content" }, [
            !_vm.isMod || _vm.isIpad
              ? _c("div", { staticClass: "goods-content-img" }, [
                  _c(
                    "div",
                    { staticClass: "img-abbr" },
                    _vm._l(_vm.fileDetails, function(fileDetail, index) {
                      return _c(
                        "span",
                        { key: index, staticClass: "img-abbr-block" },
                        [
                          _c("div", { staticClass: "abbr-img" }, [
                            _c("img", {
                              class: {
                                "abbr-img-width": _vm.getImgAbbr(fileDetail),
                                "abbr-img-height": !_vm.getImgAbbr(fileDetail)
                              },
                              attrs: {
                                src: fileDetail,
                                preview: -1,
                                datakey: index
                              },
                              on: {
                                click: function($event) {
                                  return _vm.selectImgAbbr(fileDetail, index)
                                },
                                mouseover: function($event) {
                                  return _vm.selectImgAbbr(fileDetail, index)
                                }
                              }
                            })
                          ])
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "img-pre" }, [
                    _vm.showOneClickOrder
                      ? _c("div", { staticClass: "product-vilocal-tag" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/product/product-vilocal.png")
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "img-pre-left", on: { click: _vm.prev } },
                      [
                        _c("img", {
                          attrs: { src: require("@/assets/left.png"), alt: "" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      class: {
                        "img-pre-item": _vm.imgWidth <= _vm.imgHeight,
                        "img-pre-item-width": _vm.imgWidth > _vm.imgHeight
                      },
                      attrs: { src: _vm.preImg }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "img-pre-right", on: { click: _vm.next } },
                      [
                        _c("img", {
                          attrs: { src: require("@/assets/right.png"), alt: "" }
                        })
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "img-container" },
              [
                _vm.isMod
                  ? _c(
                      "mt-swipe",
                      {
                        ref: "swipe",
                        attrs: { auto: 0, defaultIndex: _vm.defaultIndex }
                      },
                      _vm._l(_vm.fileDetails, function(img, index) {
                        return _c("mt-swipe-item", { key: index }, [
                          _vm.showOneClickOrder
                            ? _c(
                                "div",
                                { staticClass: "product-vilocal-tag" },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/img/product/product-vilocal.png")
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("img", {
                            key: index,
                            class: {
                              "img-pre-item": _vm.imgWidth <= _vm.imgHeight,
                              "img-pre-item-width": _vm.imgWidth > _vm.imgHeight
                            },
                            attrs: { src: img }
                          })
                        ])
                      }),
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "goods-content-sku" }, [
              _vm.collectionBrandId !== "" && _vm.collectionBrandId !== null
                ? _c(
                    "div",
                    {
                      staticClass: "brand-content",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c("img", {
                        staticStyle: {
                          height: "50px",
                          width: "50px",
                          float: "left",
                          border: "1px solid #e6e6e6",
                          "border-radius": "50%"
                        },
                        attrs: { src: _vm.collectionBrandLogoUrl }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "collection_brand" }, [
                        _c(
                          "div",
                          { staticClass: "brand_name_rating" },
                          [
                            _c(
                              "a",
                              {
                                staticStyle: {
                                  "font-size": "16px",
                                  color: "#262b2f",
                                  "text-decoration": "underline",
                                  "font-weight": "500",
                                  "line-height": "35px",
                                  "margin-left": "10px",
                                  float: "left",
                                  cursor: "pointer"
                                },
                                attrs: { href: "javascript:void(0)" },
                                on: { click: _vm.gotoBrand }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.collectionBrandName) +
                                    "\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.queryData["rating"]
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "total-reviews",
                                    on: {
                                      click: function($event) {
                                        _vm.showCollection = !_vm.showCollection
                                      }
                                    }
                                  },
                                  [
                                    _c("el-rate", {
                                      staticStyle: {
                                        width: "85px",
                                        "margin-top": "-5px"
                                      },
                                      attrs: {
                                        disabled: "",
                                        allowHalf: true,
                                        "disabled-void-color": "#000",
                                        "disabled-void-icon-class":
                                          "el-icon-star-off",
                                        colors: _vm.colors,
                                        "text-color": "#262B2F"
                                      },
                                      model: {
                                        value: _vm.queryData["rating"],
                                        callback: function($$v) {
                                          _vm.$set(_vm.queryData, "rating", $$v)
                                        },
                                        expression: "queryData['rating']"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "ratingStr" }, [
                                      _vm._v(_vm._s(_vm.queryData["ratingStr"]))
                                    ]),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "el-icon-arrow-down",
                                      staticStyle: { "margin-top": "-5px" }
                                    }),
                                    _vm._v(" "),
                                    _vm.showCollection
                                      ? _c(
                                          "div",
                                          {
                                            ref: "ratingCollection",
                                            staticClass: "rating-collection"
                                          },
                                          [
                                            _c(
                                              "p",
                                              [
                                                _c("span", [
                                                  _vm._v("Product Quality")
                                                ]),
                                                _vm._v(" "),
                                                _c("el-rate", {
                                                  attrs: {
                                                    disabled: "",
                                                    allowHalf: true,
                                                    colors: _vm.colors,
                                                    "disabled-void-color":
                                                      "#000",
                                                    "disabled-void-icon-class":
                                                      "el-icon-star-off",
                                                    "text-color": "#262B2F"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryData[
                                                        "descriptionRating"
                                                      ],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.queryData,
                                                        "descriptionRating",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryData['descriptionRating']"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "rating" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.queryData[
                                                          "productQuality"
                                                        ]
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              [
                                                _c("span", [
                                                  _vm._v(" Brand Service")
                                                ]),
                                                _vm._v(" "),
                                                _c("el-rate", {
                                                  attrs: {
                                                    disabled: "",
                                                    allowHalf: true,
                                                    colors: _vm.colors,
                                                    "disabled-void-color":
                                                      "#000",
                                                    "disabled-void-icon-class":
                                                      "el-icon-star-off",
                                                    "text-color": "#262B2F"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryData[
                                                        "serviceRating"
                                                      ],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.queryData,
                                                        "serviceRating",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryData['serviceRating']"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "rating" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.queryData[
                                                          "brandServiceStr"
                                                        ]
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              [
                                                _c("span", [
                                                  _vm._v(" Logistics Rating")
                                                ]),
                                                _vm._v(" "),
                                                _c("el-rate", {
                                                  attrs: {
                                                    disabled: "",
                                                    allowHalf: true,
                                                    colors: _vm.colors,
                                                    "disabled-void-color":
                                                      "#000",
                                                    "disabled-void-icon-class":
                                                      "el-icon-star-off",
                                                    "text-color": "#262B2F"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryData[
                                                        "logisticsRating"
                                                      ],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.queryData,
                                                        "logisticsRating",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryData['logisticsRating']"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "rating" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.queryData[
                                                          "logisticsRatingStr"
                                                        ]
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.queryData["brandIsVilocal"]
                              ? _c("div", { staticClass: "brand-vilocal" }, [
                                  _vm._v("ViLocal")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.salesManager !== "" && _vm.salesManager !== null
                              ? _c("el-tag", { attrs: { type: "danger" } }, [
                                  _vm._v("Top Brand")
                                ])
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          (!_vm.isMobile || _vm.isIpad) &&
                          _vm.queryData.collectionBrandSellingPoint &&
                          _vm.collectionBrandId !== "" &&
                          _vm.collectionBrandId !== null
                            ? _c("span", { staticClass: "selling-point" }, [
                                _vm._v(
                                  "\n                      (" +
                                    _vm._s(
                                      _vm.queryData.collectionBrandSellingPoint
                                    ) +
                                    ")\n                  "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("p", { staticClass: "title-main" }, [
                _vm._v(
                  "\n            " + _vm._s(_vm.goodsTitle) + "\n          "
                )
              ]),
              _vm._v(" "),
              _c("p"),
              _vm._v(" "),
              !_vm.login && _vm.showReailPrice
                ? _c("div", { staticClass: "lock-item" }, [
                    _c("img", {
                      attrs: { src: require("../../assets/img/lock1.png") }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Sign up to see wholesale price")])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.login || _vm.showWholesalePrice
                ? _c(
                    "div",
                    { staticClass: "price", staticStyle: { color: "#262b2f" } },
                    [
                      _vm.queryData["brandIsVilocal"] &&
                      _vm.skuInfo["isVilocal"] &&
                      _vm.skuInfo["vilocalType"] == 4
                        ? _c("span", [_vm._v("$ " + _vm._s(_vm.discountPrice))])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          class:
                            _vm.queryData["brandIsVilocal"] &&
                            _vm.skuInfo["isVilocal"] &&
                            _vm.skuInfo["vilocalType"] == 4 &&
                            "original-price"
                        },
                        [
                          _vm._v(
                            "$ " +
                              _vm._s(
                                Number(_vm.price)
                                  .toFixed(2)
                                  .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
                              )
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _vm.login || _vm.showReailPrice
                  ? _c(
                      "span",
                      {
                        staticClass: "sku-title",
                        staticStyle: { width: "80px" }
                      },
                      [_vm._v("Retail Price")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.login || _vm.showReailPrice
                  ? _c(
                      "label",
                      {
                        staticClass: "net-price",
                        staticStyle: { "font-size": "16px" }
                      },
                      [
                        _vm._v(
                          "\n                $" +
                            _vm._s(
                              Number(_vm.netPrice)
                                .toFixed(2)
                                .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
                            ) +
                            "\n              "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.login
                  ? _c("span", { staticClass: "margin-button" }, [
                      _vm._v(
                        "Margin " +
                          _vm._s(
                            (
                              Number(
                                (_vm.netPrice - _vm.price) / _vm.netPrice
                              ) * 100
                            ).toFixed(2)
                          ) +
                          "%"
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.login &&
              _vm.queryData["brandIsVilocal"] &&
              _vm.skuInfo["isVilocal"] &&
              _vm.skuInfo["vilocalType"] == 4
                ? _c("div", [
                    _c("span", { staticClass: "discount-trial-rate" }, [
                      _c("img", {
                        staticStyle: {
                          "margin-right": "5px",
                          "background-color": "#ff4812"
                        },
                        attrs: {
                          width: "16px",
                          height: "16px",
                          src:
                            "https://s3-amazonaws.shopvidi.com/common/test/2024103010/1575136157821255681/picture-library/1eb256af-bc46-4945-85fd-61975a7f4295.png"
                        }
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            (
                              Number(_vm.skuInfo.discountTrialDisplayRate) * 100
                            ).toFixed(0)
                          ) +
                          "% OFF\n              "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.queryData.collectionBrandShippingCountryCode
                ? _c("div", { staticClass: "ships-from" }, [
                    _vm._v(
                      "\n              Fulfills orders within " +
                        _vm._s(_vm.queryData.logisticsEfficiency) +
                        " days\n            "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.attObj.att0Flag
                ? _c(
                    "div",
                    { key: _vm.attObj.att0Name, staticClass: "sku-contont" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "sku-title sku-title-left sku-block",
                          staticStyle: { width: "100%", "margin-right": "38px" }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.attObj.att0Name) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "type-btn" },
                        _vm._l(_vm.attObj.att0Arr, function(itm, idx) {
                          return _c(
                            "span",
                            {
                              key: itm.value,
                              staticClass: "ctn-btn",
                              class: { active: idx == _vm.isActive0 },
                              attrs: { "data-key": itm.value },
                              on: {
                                click: function($event) {
                                  return _vm.checkedSizeItem(
                                    $event,
                                    idx,
                                    0,
                                    _vm.attObj.att0Name
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(itm.name) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.attObj.att1Flag
                ? _c(
                    "div",
                    { key: _vm.attObj.att1Name, staticClass: "sku-contont" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "sku-title sku-title-left sku-block",
                          staticStyle: { width: "62px", "margin-right": "38px" }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.attObj.att1Name) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "type-btn" },
                        _vm._l(_vm.attObj.att1Arr, function(itm, idx) {
                          return _c(
                            "span",
                            {
                              key: itm.value,
                              staticClass: "ctn-btn",
                              class: { active: idx == _vm.isActive1 },
                              attrs: { "data-key": itm.value },
                              on: {
                                click: function($event) {
                                  return _vm.checkedSizeItem(
                                    $event,
                                    idx,
                                    1,
                                    _vm.attObj.att1Name
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(itm.name) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.attObj.att2Flag
                ? _c(
                    "div",
                    { key: _vm.attObj.att2Name, staticClass: "sku-contont" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "sku-title sku-title-left sku-block",
                          staticStyle: { width: "62px", "margin-right": "38px" }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.attObj.att2Name) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "type-btn" },
                        _vm._l(_vm.attObj.att2Arr, function(itm, idx) {
                          return _c(
                            "span",
                            {
                              key: itm.value,
                              staticClass: "ctn-btn",
                              class: { active: idx == _vm.isActive2 },
                              attrs: { "data-key": itm.value },
                              on: {
                                click: function($event) {
                                  return _vm.checkedSizeItem(
                                    $event,
                                    idx,
                                    2,
                                    _vm.attObj.att2Name
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(itm.name) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.attObj.att3Flag
                ? _c(
                    "div",
                    { key: _vm.attObj.att3Name, staticClass: "sku-contont" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "sku-title sku-title-left sku-block",
                          staticStyle: { width: "62px", "margin-right": "38px" }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.attObj.att3Name) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "type-btn" },
                        _vm._l(_vm.attObj.att3Arr, function(itm, idx) {
                          return _c(
                            "span",
                            {
                              key: itm.value,
                              staticClass: "ctn-btn",
                              class: { active: idx == _vm.isActive3 },
                              attrs: { "data-key": itm.value },
                              on: {
                                click: function($event) {
                                  return _vm.checkedSizeItem(
                                    $event,
                                    idx,
                                    3,
                                    _vm.attObj.att3Name
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(itm.name) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.attObj.att4Flag
                ? _c(
                    "div",
                    { key: _vm.attObj.att4Name, staticClass: "sku-contont" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "sku-title sku-title-left sku-block",
                          staticStyle: { width: "62px", "margin-right": "38px" }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.attObj.att4Name) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "type-btn" },
                        _vm._l(_vm.attObj.att4Arr, function(itm, idx) {
                          return _c(
                            "span",
                            {
                              key: itm.value,
                              staticClass: "ctn-btn",
                              class: { active: idx == _vm.isActive4 },
                              attrs: { "data-key": itm.value },
                              on: {
                                click: function($event) {
                                  return _vm.checkedSizeItem(
                                    $event,
                                    idx,
                                    4,
                                    _vm.attObj.att4Name
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(itm.name) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.attObj.att5Flag
                ? _c(
                    "div",
                    { key: _vm.attObj.att5Name, staticClass: "sku-contont" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "sku-title sku-title-left sku-block",
                          staticStyle: { width: "62px", "margin-right": "38px" }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.attObj.att5Name) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "type-btn" },
                        _vm._l(_vm.attObj.att5Arr, function(itm, idx) {
                          return _c(
                            "span",
                            {
                              key: itm.value,
                              staticClass: "ctn-btn",
                              class: { active: idx == _vm.isActive5 },
                              attrs: { "data-key": itm.value },
                              on: {
                                click: function($event) {
                                  return _vm.checkedSizeItem(
                                    $event,
                                    idx,
                                    5,
                                    _vm.attObj.att5Name
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(itm.name) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "sku-title sku-block sku-title-left",
                    staticStyle: { "margin-right": "26px" }
                  },
                  [
                    _vm._v("Quantity  "),
                    _vm.goodCase > 1
                      ? _c("span", { staticStyle: { color: "#5D5D5D" } }, [
                          _vm._v("（Case size " + _vm._s(_vm.goodCase) + "）")
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("el-input-number", {
                      attrs: {
                        step: _vm.goodCase ? _vm.goodCase : 1,
                        min: _vm.moq > _vm.goodCase ? _vm.moq : _vm.goodCase
                      },
                      on: { change: _vm.changeQuantity },
                      model: {
                        value: _vm.num,
                        callback: function($$v) {
                          _vm.num = $$v
                        },
                        expression: "num"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "vilocal-type-tips" }, [
                  _vm._v(_vm._s(_vm.vilocalTypeTips))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "item-bottom" }),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-top": "50px" } }, [
                _vm.unAvailableSku
                  ? _c("div", { staticClass: "sold-out button_box" }, [
                      _c(
                        "span",
                        {
                          staticClass: "btn top-btn un-available",
                          staticStyle: {
                            "background-color": "#5D5D5D",
                            color: "#fff",
                            cursor: "not-allowed"
                          }
                        },
                        [_vm._v("Unavailable")]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.unAvailableSku &&
                (_vm.goodsStatus == "0" || _vm.skuStatus == "2")
                  ? _c("div", { staticClass: "sold-out button_box" }, [
                      _c(
                        "span",
                        {
                          staticClass: "btn top-btn",
                          staticStyle: {
                            "background-color": "hsl(0, 0%, 36%)",
                            color: "#fff",
                            cursor: "not-allowed"
                          }
                        },
                        [_vm._v("Sold Out")]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.goodsStatus === "1" &&
                (_vm.skuStatus == "1" || _vm.skuStatus === "")
                  ? _c(
                      "div",
                      { staticClass: "button_box" },
                      [
                        _vm.showOneClickOrder
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: _vm.tipContent,
                                  placement: "top-start"
                                }
                              },
                              [
                                !_vm.isExitsViLocalOrder &&
                                _vm.collectionBrandVilocalStatus !== 2
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "btn add-btn top-btn",
                                        staticStyle: {
                                          border: "1px solid #F3E93D",
                                          "background-color": "#F3E93D",
                                          color: "#262613",
                                          "margin-right": "10px"
                                        },
                                        on: { click: _vm.oneClickOrder }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Get ViLocal Order\n                "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass: "btn add-btn top-btn",
                                        staticStyle: {
                                          border: "1px solid #B9B9B9",
                                          "background-color": "#B9B9B9",
                                          color: "#FFFFFF",
                                          "margin-right": "10px",
                                          cursor: "auto"
                                        },
                                        on: { click: _vm.oneClickOrder }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Get ViLocal Order\n                "
                                        )
                                      ]
                                    )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showOneClickOrder &&
                        (_vm.isExitsViLocalOrder ||
                          _vm.collectionBrandVilocalStatus === 2)
                          ? _c("span", { staticClass: "mobile-tips" }, [
                              _vm._v(_vm._s(_vm.tipContent))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showAddToCart && !_vm.unAvailableSku
                          ? _c(
                              "span",
                              {
                                staticClass: "btn add-btn top-btn",
                                staticStyle: {
                                  border: "1px solid #000",
                                  "background-color": "#262b2f",
                                  color: "#fff"
                                },
                                on: { click: _vm.addCart }
                              },
                              [
                                _vm._v("\n                Add "),
                                _vm.login
                                  ? _c("span", [
                                      _vm._v("$" + _vm._s(_vm.totalPrice))
                                    ])
                                  : _vm._e(),
                                _vm._v(" to Cart\n              ")
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.skuStatus == "0"
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticStyle: { "font-size": "12px", color: "#5D5D5D" }
                        },
                        [
                          _vm._v(
                            "This item is temporarily out of stock，restock by " +
                              _vm._s(_vm._f("datefmt")(_vm.restockDate, "L"))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn add-btn",
                          staticStyle: {
                            "margin-top": "8px",
                            border: "1px solid #000",
                            "background-color": "#5D5D5D",
                            color: "#fff",
                            cursor: "not-allowed"
                          }
                        },
                        [
                          _vm._v(
                            "\n               Out of Stock\n              "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "m-ships-from" }, [
                  _vm._v(
                    "\n              Fulfills orders within " +
                      _vm._s(_vm.queryData.logisticsEfficiency) +
                      " days\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ships-free" }, [
                  _vm.firstOrder
                    ? _c("span", { staticClass: "free-first-order" }, [
                        _vm._v("Free Shipping on Opening Order")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.collectionBrandId !== "" && _vm.collectionBrandId !== null
                    ? _c("div", { staticClass: "m-title" }, [
                        _c("div", { staticClass: "m-title-logo" }, [
                          _c("img", {
                            staticStyle: {
                              height: "45px",
                              width: "45px",
                              float: "left",
                              border: "1px solid #e6e6e6",
                              "border-radius": "50%"
                            },
                            attrs: { src: _vm.collectionBrandLogoUrl }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "m-title-text",
                            staticStyle: { position: "relative", top: "-10px" }
                          },
                          [
                            _c("div", [
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "font-size": "16px",
                                    color: "#262b2f",
                                    "font-weight": "500",
                                    cursor: "pointer",
                                    "font-family": "Satoshi-Medium",
                                    "text-decoration": "none"
                                  },
                                  attrs: { href: "javascript:void(0)" },
                                  on: { click: _vm.gotoBrand }
                                },
                                [_vm._v(_vm._s(_vm.collectionBrandName))]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.queryData["rating"]
                          ? _c(
                              "div",
                              {
                                staticClass: "total-reviews",
                                on: {
                                  click: function($event) {
                                    _vm.showCollection = !_vm.showCollection
                                  }
                                }
                              },
                              [
                                _c("el-rate", {
                                  staticStyle: { width: "80px" },
                                  attrs: {
                                    disabled: "",
                                    allowHalf: true,
                                    colors: _vm.colors,
                                    "disabled-void-color": "#000",
                                    "disabled-void-icon-class":
                                      "el-icon-star-off",
                                    "text-color": "#262B2F"
                                  },
                                  model: {
                                    value: _vm.queryData["rating"],
                                    callback: function($$v) {
                                      _vm.$set(_vm.queryData, "rating", $$v)
                                    },
                                    expression: "queryData['rating']"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "ratingStr" }, [
                                  _vm._v(_vm._s(_vm.queryData["ratingStr"]))
                                ]),
                                _vm._v(" "),
                                _c("i", { staticClass: "el-icon-arrow-down" }),
                                _vm._v(" "),
                                _vm.showCollection
                                  ? _c(
                                      "div",
                                      {
                                        ref: "ratingCollection",
                                        staticClass: "rating-collection"
                                      },
                                      [
                                        _c(
                                          "p",
                                          [
                                            _c("span", [
                                              _vm._v("Product Quality")
                                            ]),
                                            _vm._v(" "),
                                            _c("el-rate", {
                                              attrs: {
                                                disabled: "",
                                                allowHalf: true,
                                                colors: _vm.colors,
                                                "disabled-void-color": "#000",
                                                "disabled-void-icon-class":
                                                  "el-icon-star-off",
                                                "text-color": "#262B2F"
                                              },
                                              model: {
                                                value:
                                                  _vm.queryData[
                                                    "descriptionRating"
                                                  ],
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.queryData,
                                                    "descriptionRating",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryData['descriptionRating']"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "rating" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.queryData[
                                                      "productQuality"
                                                    ]
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          [
                                            _c("span", [
                                              _vm._v(" Brand Service")
                                            ]),
                                            _vm._v(" "),
                                            _c("el-rate", {
                                              attrs: {
                                                disabled: "",
                                                allowHalf: true,
                                                colors: _vm.colors,
                                                "disabled-void-color": "#000",
                                                "disabled-void-icon-class":
                                                  "el-icon-star-off",
                                                "text-color": "#262B2F"
                                              },
                                              model: {
                                                value:
                                                  _vm.queryData[
                                                    "serviceRating"
                                                  ],
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.queryData,
                                                    "serviceRating",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryData['serviceRating']"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "rating" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.queryData[
                                                      "brandServiceStr"
                                                    ]
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          [
                                            _c("span", [
                                              _vm._v(" Logistics Rating")
                                            ]),
                                            _vm._v(" "),
                                            _c("el-rate", {
                                              attrs: {
                                                disabled: "",
                                                allowHalf: true,
                                                colors: _vm.colors,
                                                "disabled-void-color": "#000",
                                                "disabled-void-icon-class":
                                                  "el-icon-star-off",
                                                "text-color": "#262B2F"
                                              },
                                              model: {
                                                value:
                                                  _vm.queryData[
                                                    "logisticsRating"
                                                  ],
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.queryData,
                                                    "logisticsRating",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryData['logisticsRating']"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "rating" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.queryData[
                                                      "logisticsRatingStr"
                                                    ]
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isMobile
                    ? _c("div", { staticClass: "m-brand-tag" }, [
                        _vm.queryData["brandIsVilocal"] ||
                        (_vm.salesManager !== "" && _vm.salesManager !== null)
                          ? _c(
                              "div",
                              { staticClass: "m-brand-tag-top" },
                              [
                                _vm.queryData["brandIsVilocal"]
                                  ? _c(
                                      "div",
                                      { staticClass: "brand-vilocal" },
                                      [_vm._v("ViLocal")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.salesManager !== "" &&
                                _vm.salesManager !== null
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [_vm._v("Top Brand")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.collectionBrandId !== "" &&
                        _vm.collectionBrandId !== null &&
                        _vm.queryData.collectionBrandSellingPoint &&
                        _vm.isMobile
                          ? _c("div", [
                              _vm._v(
                                "(" +
                                  _vm._s(
                                    _vm.queryData.collectionBrandSellingPoint
                                  ) +
                                  ")"
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "return-policy" },
                  [
                    _c("el-divider"),
                    _vm._v("\n                Return Policy\n                "),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "return-policy content" }, [
                      _vm._v(
                        "We offer free returns for our customer on the first order based on the conditions:"
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "return-policy content" }, [
                      _vm._v(
                        "1" +
                          _vm._s(")") +
                          " Within 60 after placing the order, or within 14 days of receiving the products."
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "return-policy content" }, [
                      _vm._v(
                        "2" +
                          _vm._s(")") +
                          " Only applicable to the first order of each brand, and the refund amount cannot exceed $200."
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", { staticClass: "return-policy content" }, [
                      _vm._v(
                        "3" +
                          _vm._s(")") +
                          " Standard products only, customized products, testers, or sample items can’t be returned."
                      )
                    ])
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "goods-desc-content" },
            [
              _c(
                "el-tabs",
                {
                  on: { change: _vm.changeTabs },
                  model: {
                    value: _vm.tabsKey,
                    callback: function($$v) {
                      _vm.tabsKey = $$v
                    },
                    expression: "tabsKey"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { name: "1", label: "Product Details" } },
                    [
                      _c("div", { staticClass: "return-policy-mobile" }, [
                        _vm._v(
                          "\n                Return Policy\n                "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "return-policy-mobile content" },
                          [
                            _vm._v(
                              "We offer free returns for our customer on the first order based on the conditions:"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "return-policy-mobile content" },
                          [
                            _vm._v(
                              "1" +
                                _vm._s(")") +
                                " Within 60 after placing the order, or within 14 days of receiving the products."
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "return-policy-mobile content" },
                          [
                            _vm._v(
                              "2" +
                                _vm._s(")") +
                                " Only applicable to the first order of each brand, and the refund amount cannot exceed $200."
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "return-policy-mobile content" },
                          [
                            _vm._v(
                              "3" +
                                _vm._s(")") +
                                " Standard products only, customized products, testers, or sample items can’t be returned."
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.descInfo
                        ? _c("ProductHtml", {
                            staticStyle: { width: "100%" },
                            attrs: { descInfo: _vm.descInfo }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    {
                      staticClass: "specification",
                      staticStyle: {
                        background: "#ffffff",
                        width: "100%",
                        height: "100vh"
                      },
                      attrs: { name: "2", label: "Specification" }
                    },
                    [
                      _c("p", { staticStyle: { "line-height": "30px" } }, [
                        _c("strong", [_vm._v("SPU id:")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.id))])
                      ]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "line-height": "30px" } }, [
                        _c("strong", [_vm._v("SKU id:")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.vdSku))])
                      ]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "line-height": "30px" } }, [
                        _c("strong", [_vm._v("Weight:")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.weight) + _vm._s(_vm.unit))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "line-height": "30px" } }, [
                        _c("strong", [_vm._v("Dimensions:")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.dimensions))])
                      ]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "line-height": "30px" } }, [
                        _c("strong", [_vm._v("Case size:")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.goodCase))])
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "brandRecommendDiv" },
        [
          _c("brand-recommend-vue", {
            ref: "brandRecommend",
            attrs: {
              queryData: _vm.queryData,
              isMobile: _vm.isMobile,
              isIpad: _vm.isIpad
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "moreRecommendDiv" },
        [
          _c("more-recommend-vue", {
            ref: "moreRecommend",
            attrs: {
              queryData: _vm.queryData,
              isMobile: _vm.isMobile,
              isIpad: _vm.isIpad
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "recentlyViewedDiv" },
        [
          _c("recently-viewed-vue", {
            ref: "recentlyViewed",
            attrs: {
              queryData: _vm.queryData,
              isMobile: _vm.isMobile,
              isIpad: _vm.isIpad
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.login
        ? _c(
            "div",
            { staticClass: "vilocal-zone-main4", attrs: { id: "sign-up" } },
            [
              _c("div", { staticClass: "vilocal-zone-main1-form-container" }, [
                _c("div", { staticClass: "main1-form-title" }, [
                  _vm._v(
                    "Join us for the latest ViLocal Brand And get ViLocal Brand 100% discount"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vilocal-zone-main1-form-content" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "registerForm",
                        staticClass: "vilocal-zone-main1-form",
                        attrs: {
                          model: _vm.registerForm,
                          inline: !_vm.isMobile,
                          rules: _vm.rules
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "email" } },
                          [
                            _c("div", { staticClass: "required-icon" }, [
                              _vm._v("*")
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "email-input-main1",
                              attrs: {
                                placeholder: "Business Email",
                                oninput: "if(value){value=value.toLowerCase()}",
                                onblur: "if(value){value=value.trim()}"
                              },
                              model: {
                                value: _vm.registerForm.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.registerForm, "email", $$v)
                                },
                                expression: "registerForm.email"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isMobile
                          ? _c(
                              "div",
                              { staticStyle: { display: "inline-block" } },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 10 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 11 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass:
                                              "flex cust-form-item cust-form-item2",
                                            attrs: {
                                              "label-position": "right",
                                              prop: "phone"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "phone-div" },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass:
                                                      "code-input-main1",
                                                    attrs: {
                                                      filterable: "",
                                                      placeholder:
                                                        "+ Country Code"
                                                    },
                                                    on: {
                                                      change: _vm.codeChange
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.registerForm.code,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.registerForm,
                                                          "code",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "registerForm.code"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "empty" },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticStyle: {
                                                              display: "none"
                                                            }
                                                          },
                                                          [_vm._v("no data")]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.options,
                                                      function(item, index) {
                                                        return _c(
                                                          "el-option",
                                                          {
                                                            key: index,
                                                            attrs: {
                                                              label: item.text,
                                                              value: item
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  float: "left"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.text
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  float:
                                                                    "right",
                                                                  color:
                                                                    "#8492a6",
                                                                  "font-size":
                                                                    "13px"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.value
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass: "divider"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "required-icon-phone"
                                                  },
                                                  [_vm._v("*")]
                                                ),
                                                _vm._v(" "),
                                                _c("el-input", {
                                                  staticClass:
                                                    "phone-input-main1",
                                                  attrs: {
                                                    placeholder: "Phone"
                                                  },
                                                  on: {
                                                    input: _vm.changePhone
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.registerForm.phone,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.registerForm,
                                                        "phone",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "registerForm.phone"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 13 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { prop: "onlineShopType" } },
                                          [
                                            _vm.isMobile
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "required-icon"
                                                  },
                                                  [_vm._v("*")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "el-select",
                                              {
                                                staticClass:
                                                  "store-type-input-main1",
                                                attrs: {
                                                  placeholder: "Store Type"
                                                },
                                                model: {
                                                  value:
                                                    _vm.registerForm
                                                      .onlineShopType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.registerForm,
                                                      "onlineShopType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "registerForm.onlineShopType"
                                                }
                                              },
                                              _vm._l(_vm.storeType, function(
                                                item,
                                                index
                                              ) {
                                                return _c("el-option", {
                                                  key: item.textTitle,
                                                  attrs: {
                                                    label: item.textTitle,
                                                    value: index
                                                  }
                                                })
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isMobile
                          ? _c(
                              "el-form-item",
                              {
                                staticClass:
                                  "flex cust-form-item cust-form-item2",
                                attrs: { prop: "phone" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "phone-div" },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "code-input-main1",
                                        attrs: {
                                          filterable: "",
                                          placeholder: "+ Country Code"
                                        },
                                        on: { change: _vm.codeChange },
                                        model: {
                                          value: _vm.registerForm.code,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.registerForm,
                                              "code",
                                              $$v
                                            )
                                          },
                                          expression: "registerForm.code"
                                        }
                                      },
                                      [
                                        _c("template", { slot: "empty" }, [
                                          _c(
                                            "p",
                                            {
                                              staticStyle: { display: "none" }
                                            },
                                            [_vm._v("no data")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(_vm.options, function(
                                          item,
                                          index
                                        ) {
                                          return _c(
                                            "el-option",
                                            {
                                              key: index,
                                              attrs: {
                                                label: item.text,
                                                value: item
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: { float: "left" }
                                                },
                                                [_vm._v(_vm._s(item.text))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "right",
                                                    color: "#8492a6",
                                                    "font-size": "13px"
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.value))]
                                              )
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "divider" }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "required-icon-phone",
                                        staticStyle: { "{left": "80px" }
                                      },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "phone-input-main1",
                                      attrs: { placeholder: "Phone" },
                                      on: { input: _vm.changePhone },
                                      model: {
                                        value: _vm.registerForm.phone,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.registerForm,
                                            "phone",
                                            $$v
                                          )
                                        },
                                        expression: "registerForm.phone"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isMobile
                          ? _c(
                              "el-form-item",
                              { attrs: { prop: "onlineShopType" } },
                              [
                                _c("div", { staticClass: "required-icon" }, [
                                  _vm._v("*")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "store-type-input-main1",
                                    attrs: { placeholder: "Store Type" },
                                    model: {
                                      value: _vm.registerForm.onlineShopType,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.registerForm,
                                          "onlineShopType",
                                          $$v
                                        )
                                      },
                                      expression: "registerForm.onlineShopType"
                                    }
                                  },
                                  _vm._l(_vm.storeType, function(item, index) {
                                    return _c("el-option", {
                                      key: item.textTitle,
                                      attrs: {
                                        label: item.textTitle,
                                        value: index
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "storeName" } },
                          [
                            _c("div", { staticClass: "required-icon" }, [
                              _vm._v("*")
                            ]),
                            _vm._v(" "),
                            _c("el-autocomplete", {
                              staticClass: "store-name-input-main1",
                              attrs: {
                                "popper-class": "my-autocomplete",
                                "trigger-on-focus": false,
                                "fetch-suggestions": _vm.getGoogleMap,
                                placeholder: "Store Name"
                              },
                              on: { select: _vm.handleSelect },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var item = ref.item
                                      return [
                                        _c("span", [
                                          _c("img", {
                                            staticClass: "sit_img",
                                            attrs: {
                                              src:
                                                "https://shopvidi.oss-cn-beijing.aliyuncs.com/shopvidi-1.4.1/google1.png",
                                              alt: ""
                                            }
                                          })
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(item.label))
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "gray",
                                              "margin-left": "2px"
                                            }
                                          },
                                          [_vm._v(" , " + _vm._s(item.address))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                932733711
                              ),
                              model: {
                                value: _vm.registerForm.storeName,
                                callback: function($$v) {
                                  _vm.$set(_vm.registerForm, "storeName", $$v)
                                },
                                expression: "registerForm.storeName"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "storeAddress" } },
                          [
                            !_vm.isMobile
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "required-icon",
                                    staticStyle: { top: "0" }
                                  },
                                  [_vm._v("*")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isMobile
                              ? _c("el-input", {
                                  staticClass: "store-address-input-main1",
                                  attrs: {
                                    placeholder: "Store Address",
                                    type: "textarea",
                                    rows: 4,
                                    resize: "none"
                                  },
                                  model: {
                                    value: _vm.registerForm.storeAddress,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.registerForm,
                                        "storeAddress",
                                        $$v
                                      )
                                    },
                                    expression: "registerForm.storeAddress"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isMobile
                              ? _c("div", { staticClass: "required-icon" }, [
                                  _vm._v("*")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isMobile
                              ? _c("el-input", {
                                  staticClass: "store-address-input-main1",
                                  attrs: { placeholder: "Store Address" },
                                  model: {
                                    value: _vm.registerForm.storeAddress,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.registerForm,
                                        "storeAddress",
                                        $$v
                                      )
                                    },
                                    expression: "registerForm.storeAddress"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "interestedCategory" } },
                          [
                            _c("div", { staticClass: "required-icon" }, [
                              _vm._v("*")
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                ref: "interestedCategorySelect",
                                staticClass: "interested-category-input-main1",
                                attrs: {
                                  placeholder: "Interested Category",
                                  multiple: "",
                                  "multiple-limit": 5
                                },
                                on: { change: _vm.changeCategory },
                                model: {
                                  value: _vm.registerForm.interestedCategory,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.registerForm,
                                      "interestedCategory",
                                      $$v
                                    )
                                  },
                                  expression: "registerForm.interestedCategory"
                                }
                              },
                              [
                                _vm._l(
                                  _vm.vilocalSecondClassCategories,
                                  function(item, index) {
                                    return _c("el-option", {
                                      key: item.storeTypeName,
                                      attrs: {
                                        label: item.storeTypeName,
                                        value: index
                                      }
                                    })
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-option",
                                  {
                                    key: "clear",
                                    staticClass: "not-find-option",
                                    attrs: { value: "-1" }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("Can’t find your Category? "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "text-decoration": "underline",
                                            "text-underline-offset": "3px",
                                            "text-underline": "#333333"
                                          }
                                        },
                                        [_vm._v("Click Here")]
                                      )
                                    ])
                                  ]
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "vilocal-zone-main1-button",
                    on: {
                      click: function($event) {
                        return _vm.submit("registerForm")
                      }
                    }
                  },
                  [_vm._v("Get free trial sales NOW!")]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "creae-cate-info",
          attrs: {
            "show-close": true,
            visible: _vm.createCategoryVisible,
            "destroy-on-close": "",
            width: _vm.IS_MOBILE ? "100%" : "355px",
            "close-on-click-modal": true
          },
          on: {
            "update:visible": function($event) {
              _vm.createCategoryVisible = $event
            }
          }
        },
        [
          _c("p", [_vm._v("Interested Category")]),
          _vm._v(" "),
          _c("el-input", {
            attrs: { placeholder: "Enter Interested Category" },
            model: {
              value: _vm.newInterestedCategory,
              callback: function($$v) {
                _vm.newInterestedCategory = $$v
              },
              expression: "newInterestedCategory"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "submit",
              on: { click: _vm.createInterestedCategory }
            },
            [_vm._v("Submit")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("home-footer"),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-item add-dialog-item detail-dialog",
          attrs: {
            visible: _vm.showThemeForm,
            title: "Add Theme",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.showThemeForm = $event
            },
            close: function($event) {
              _vm.themeName = ""
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.saveTheme(false)
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "submit-btn",
                  attrs: { loading: _vm.saveLoading },
                  on: {
                    click: function($event) {
                      return _vm.saveTheme(true)
                    }
                  }
                },
                [_vm._v("\n                Save\n              ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            attrs: { placeholder: "Please enter a theme name" },
            model: {
              value: _vm.themeName,
              callback: function($$v) {
                _vm.themeName = $$v
              },
              expression: "themeName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-item add-dialog-item detail-dialog",
          attrs: {
            title: "Tips",
            visible: _vm.confimDeleteVis,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.confimDeleteVis = $event
            }
          }
        },
        [
          _c("span", [_vm._v("Are you sure to delete!")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.confimDeleteVis = false
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "submit-btn",
                  attrs: { loading: _vm.deleteItemLoading },
                  on: { click: _vm.deleteItemMethods }
                },
                [_vm._v("Submit")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-item add-dialog-item detail-dialog",
          attrs: { title: "Add to Imports List", visible: _vm.visible },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: { "label-col": { span: 6 }, "wrapper-col": { span: 16 } }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Products theme" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { filterable: "", placeholder: "" },
                      on: { change: _vm.handleChangeByTheme },
                      model: {
                        value: _vm.selTheme,
                        callback: function($$v) {
                          _vm.selTheme = $$v
                        },
                        expression: "selTheme"
                      }
                    },
                    _vm._l(_vm.themeArr, function(item, index) {
                      return _c(
                        "el-option",
                        {
                          key: item.value,
                          attrs: { value: item.value, label: item.label }
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(" " + _vm._s(item.label))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-right": "10px"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.confimDelete(item)
                                }
                              }
                            },
                            [_c("i", { staticClass: "el-icon-delete" })]
                          )
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "add-theme",
                      on: { click: _vm.openThemeForm }
                    },
                    [_vm._v("+ Add Theme")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.handleOk(true)
                    }
                  }
                },
                [_vm._v("Skip and import list")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "submit-btn",
                  attrs: { loading: _vm.subLoading },
                  on: {
                    click: function($event) {
                      return _vm.handleOk(false)
                    }
                  }
                },
                [_vm._v("\n                Submit\n              ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-item detail-dialog",
          attrs: { visible: _vm.showShippingMethod, title: "Shipping Method" },
          on: {
            "update:visible": function($event) {
              _vm.showShippingMethod = $event
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.saveShippingMethod(false)
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "submit-btn",
                  on: {
                    click: function($event) {
                      return _vm.saveShippingMethod(true)
                    }
                  }
                },
                [_vm._v("Save")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            { ref: "form", attrs: { "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Shipping From:" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        filterable: "",
                        placeholder: "Select Shipping From"
                      },
                      on: { change: _vm.handleChangeShoppingFrom },
                      model: {
                        value: _vm.shippingFromValue,
                        callback: function($$v) {
                          _vm.shippingFromValue = $$v
                        },
                        expression: "shippingFromValue"
                      }
                    },
                    _vm._l(_vm.startCountryCodeList, function(item) {
                      return _c(
                        "el-option",
                        {
                          key: item.value,
                          attrs: { value: item.value, label: item.label }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.label) +
                              "\n            "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Ship to:" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        "default-value": "US",
                        filterable: "",
                        placeholder: "Select Ship to"
                      },
                      on: { change: _vm.handleChange },
                      model: {
                        value: _vm.shippingToValue,
                        callback: function($$v) {
                          _vm.shippingToValue = $$v
                        },
                        expression: "shippingToValue"
                      }
                    },
                    _vm._l(_vm.countryCodeList, function(item) {
                      return _c(
                        "el-option",
                        {
                          key: item.code,
                          attrs: { value: item.code, label: item.nameEn }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.nameEn) +
                              "\n            "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "shopMethod" }, [
            _vm._v(
              "\n        The selected shipping method is shown in the price list. This is\n        provided by ShopVidi based on your chosen country/region and standard\n        delivery method (e.g. ePacket). Note: This is the cost of sending a\n        single item and does not include advanced or bulk sending options.\n      "
            )
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: { "highlight-current-row": "", data: _vm.shopMethodList },
              on: { "current-change": _vm.onSelectChange }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "logisticsName",
                  label: "Shipping Method",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "arrivalTime",
                  label: "Delivery Time Estimate(Business Days)",
                  align: "center",
                  width: "300px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "postage",
                  label: "Shipping Cost",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [_vm._v(_vm._s("$" + scope.row.postage))])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98596bd0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98596bd0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/detail/index.vue
// module id = null
// module chunks = 